// extracted by mini-css-extract-plugin
module.exports = {"collection":"jut__TagCollection__collection","expanded":"jut__TagCollection__expanded","collectionTag":"jut__TagCollection__collectionTag"};